import { Pipe, PipeTransform } from '@angular/core';
import {
  OperationsUrlSettingsFascicolo as ops
} from "../../lavoro/fascicoloGeneric/configuration/operations-url-settings-fascicolo";

@Pipe({
    name: 'titleAmianto'
})
export class TitleAmiantoPipe implements PipeTransform {
  transform(nameFascicolo: any): any {
    if (!nameFascicolo) {
      return nameFascicolo;
    }
    let titleFascicolo;
    if (nameFascicolo.toLowerCase() === 'amiantogiudiziale') { // UrlSettingsCore.NOME_FASCICOLO_FRONT_END_AMIANTO_GIUDIZIALE_LAVORO) {
      titleFascicolo = ops.NAME_FOR_HTML('amianto'); // UrlSettingsCore.NOME_FASCICOLO_FRONT_END_AMIANTO_LAVORO);
    } else {
      titleFascicolo = nameFascicolo;
    }
    return titleFascicolo;
  }
}
